<template>
  <div class="animated fadeIn">
    <b-card>
      <div slot="header">
        <span>{{ title || $t('profile.title') }}</span>
        <slot name="inheader"></slot>
      </div>
      <div v-if="spinners.contentIsLoading" class="text-center">
        <b-spinner type="grow" variant="primary"/>
      </div>
      <div v-else>
        <b-form-row>
          <b-col cols="12" md="6">
            <b-form-group :label="$t('profile.name')" :invalid-feedback="fErr('name')" :disabled="isDisabled">
              <b-form-input type="text" :placeholder="$t('profile.name_placeholder')"
                :class="{ 'is-invalid' : fErr('name') }" v-model="entity.name"/>
            </b-form-group>
            <b-form-group :label="$t('profile.surname')" :invalid-feedback="fErr('surname')" :disabled="isDisabled">
              <b-form-input type="text" :placeholder="$t('profile.surname_placeholder')"
                :class="{ 'is-invalid' : fErr('surname') }" v-model="entity.surname"/>
            </b-form-group>
            <b-form-group :label="$t('profile.email')" :invalid-feedback="fErr('email')" disabled>
              <b-form-input type="email" :placeholder="$t('profile.email')"
                :class="{ 'is-invalid' : fErr('email') }" v-model="entity.email"/>
            </b-form-group>
            <b-button v-if="!changePasswordCard" variant="info" size="sm" @click="changePasswordCard = true">
              <i class="icon-lock"/><span class="ml-2">{{ $t('profile.change_password') }}</span>
            </b-button>
            <ChangePassword v-else
              :oldPassword="this.user && !this.user.isAdmin"
              :userId="entity.id"
              @close="changePasswordCard = false"/>
          </b-col>
        </b-form-row>
      </div>
      <div v-if="!isEmbedded" slot="footer">
        <div class="pull-right">
          <b-button type="submit" variant="primary" :disabled="spinners.isSaving" @click="save()">
            <b-spinner v-if="spinners.isSaving" type="grow" small/>
            {{ $t('global.save') }}
          </b-button>
          <router-link :to="{ name: 'Dashboard'}">
            <b-button type="reset" variant="info" class="ml-2">{{ $t('global.cancel') }}</b-button>
          </router-link>
        </div>
      </div>
    </b-card>
  </div>
</template>

<script>
import merge from 'lodash.merge';
import Services from '@/services/index';
import ChangePassword from '@/views/Administration/Users/ChangePassword.vue';
import { mapGetters } from 'vuex';

export default {
  mounted() {
    if (!this.isEmbedded) {
      this.load();
    }
  },
  props: {
    // If id === null, form will be considered create form else update
    id: { type: [Number, String], default: null },
    // if title == false to hide header, pass string to override default title
    title: { type: [String, Boolean], default: undefined },
    // if disabled === true, form disabled, can be enabled and edited.
    disabled: { type: [Boolean], default: false },
    // pass errors from parent form if embedded
    errors: { type: Object, default() { return {}; } },
    // value is used both as DEFAULTs placeholder and for v-model
    value: {
      type: Object,
      default() {
        return {
          name: '',
          surname: '',
          email: '',
          password: '',
          password_confirmation: '',
        };
      },
    },
  },
  data() {
    return {
      spinners: {
        contentIsLoading: false,
        isChangingActive: false,
        isSaving: false,
      },
      seePasswords: false,
      changePasswordCard: false,
      entity: this.value,
      errorMsg: this.errors,
    };
  },
  components: { ChangePassword },
  computed: {
    // embedded form will have value passed using v-model, we could also make a custom prop for checking this
    isEmbedded() { return this.$options.propsData.value !== undefined; },
    isUpdateForm() { return this.id !== null; },
    isDisabled() { return this.disabled; },
    ...mapGetters('Auth', [
      'user',
    ]),
  },
  watch: {
    errors() { this.errorMsg = this.errors; },
  },
  methods: {
    getForUpdate: Services.authUserData.myProfileData,
    update: Services.authUserData.myProfileUpdate,
    load() {
      this.getForUpdate().then((res) => {
        this.spinners.contentIsLoading = false;
        this.entity = res.data;
      }).catch((res) => {
        this.spinners.contentIsLoading = false;
        this.errorMsg = res.data ? res.data.errors : {};
      });
    },
    save() {
      if (this.isEmbedded) return;
      this.spinners.isSaving = true;
      this.update(this.entity).then((res) => {
        this.spinners.isSaving = false;
        this.alertSuccess();
        merge(this.entity, res.data); // This will not delete keys but will preserve original object
        this.errorMsg = {};
      }).catch(({ errors, message }) => {
        this.spinners.isSaving = false;
        this.errorMsg = errors;
        this.alertError({ text: message });
      });
    },
  }
};
</script>

<style scoped>
</style>
